<template>
    <div class="taskStatistics">
        <div class="pad14">
            <el-select class="marr4" v-model="fcname" size="mini" placeholder="请选择分厂" @change="changeGroup" filterable required :disabled="edit">
                <el-option
                        v-for="itembm in groupName"
                        :key="itembm.id"
                        :label="itembm.name"
                        :value="itembm.id">
                </el-option>
            </el-select>
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>
            <el-button :class="baseerp+'btn'" icon="el-icon-search"  size="mini" type="primary" @click="gosearch"></el-button>
            <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="outPut">导出</el-button>
        </div>
        <el-table
                v-loading="loading"
                ref="table"
                size="mini"
                :height="tableHeight"
                border
                :data="tableData"
                style="width: 100%">
            <el-table-column
                    prop="row"
                    type="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="分厂/部门"
                    prop="fcName">
            </el-table-column>
            <el-table-column
                    align="center"
                    label="工段"
                    prop="gdName"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="班组"
                    prop="bzName"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="岗位"
                    prop="station"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="人员"
                    prop="uName"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="应巡检总数"
                    prop="total"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="完成"
                    prop="complete"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="未完成"
                    prop="incomplete"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="待完成"
                    prop="tbcomplete"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="完成率"
                    prop="completeRatio"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="未完成率"
                    prop="incompleteRatio"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    align="center"
                    label="状态"
                    :formatter="Status"
                    prop="i_state"
                    show-overflow-tooltip>
            </el-table-column>-->
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        @current-change="pageCurrentChange"
                        layout="total,prev, pager, next"
                        :page-size="pageSize"
                        :current-page.sync="currentPage"
                        :total="total">
        </el-pagination>
        <reportdialog  ref="mydialog"   ></reportdialog>
        <eDialog ref="eDialog" :activePage="activePage"></eDialog>
    </div>

</template>

<script>
    import * as API from  "../api";
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    export default {
        name: 'taskStatistics',
        components: {
            eDialog,
            reportdialog,
        },
        data(){
            return{
                loading:true,
                activePage:"report/res/spread.vue",
                currentPage:1,
                pageSize:20,
                total:0,
                tableData:[],
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                fcids:'',
                fcid:0,
                fcname:"",
                groupName:[],
                edit:false,
                baseerp:'',
                tableHeight:0,
                mid:0,
            }
        },
        mounted() {
            this.getfMou();
            this.baseerp=baseerp;
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;
            },
            gosearch(){
                this.currentPage=1;
                this.tableData=[];
                if(this.fcid==0){
                    this.ryxjList(this.fcids);
                }else{
                    this.ryxjList();
                }

            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getGroupList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
            },
            outPut(){
                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                this.$refs.eDialog.showDialog({title:"导出",parm:{type:'personDcsRpt',mid:this.$route.meta.mid,arg:{fid: this.fcid!=0?this.fcid:this.fcids,sDate:this.dt_startdate,eDate:this.dt_enddate}},w:1024,h:768});
                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                })
            },
            async getGroupList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid: this.mid,
                    i_type: "1",
                };
                let res=await API.fcList(param);
                if(res.code==1){
                    if(res.tasksList.length==0){
                        this.$message.error('暂无分厂权限！');
                        this.fcid= 0;
                        this.fcname= '';
                        this.ryxjList();
                    }else{
                        let fcidArr=[];
                        res.tasksList.map(item=>{
                            if(item.id!=0){
                                fcidArr.push(item.id)
                            }
                        });
                        //console.log(fcidArr,'fcidArr');
                        this.fcids=fcidArr.toString();
                        //console.log(this.fcids,'this.fcids');
                        this.groupName=res.tasksList;
                        this.fcid= this.groupName[0].id;
                        this.fcname= this.groupName[0].name;
                        this.ryxjList(this.fcids);
                    }

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            changeGroup(val){
                //console.log('val',val);
                this.fcid=val?val:0;
            },
            //列表list
            async ryxjList(ids){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    'i_mid':this.mid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'fid':ids?ids:this.fcid,
                    'sDate':this.dt_startdate,
                    'eDate':this.dt_enddate,
                };
                var res = await API.ryxjList(param);
                if (res.code==1){
                    this.tableData=res.tasksList;
                    this.total=res.total;
                    this.loading=false;
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                this.currentPage=val;
                this.ryxjList(this.fcid==0?this.fcids:this.fcid);
            },
            Status(row, column, cellValue, index){
                /*if(row.i_state==0){
                    return '未提交'
                }else if(row.i_state==1){
                    return '审核中'
                }*/
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" scoped>
    .pad14{
        padding: 6px 14px;
    }
    .marr4{
        margin-right: 4px;
    }

</style>








